import React from 'react';
import ReactDOM from 'react-dom';
import DynamicNav from '../components/DynamicNav';
import { PageContext } from '../frontend/pageContext';
import Header from '../components/Header';
import BannerHistory from '../components/BannerHistory';
import { setMenuExpanded, decorateClientMenu } from './utils';

// Save menu scroll position and set before any dom is displayed (if this were in useEffect, there would be a flashing)
const menuElement = document.getElementById('js-menu');
const contentAreaEl = document.querySelector<HTMLElement>('.content-area');
const footerEl = document.querySelector<HTMLElement>('.suds-footer');
const breadcrumbsEl = document.querySelector<HTMLElement>('.breadcrumb_list');
const bannerSectionsEl =
  document.querySelector<HTMLElement>('.banners-section');
const asideEl = document.querySelector<HTMLElement>('aside');

function setPosition() {
  if (contentAreaEl) {
    contentAreaEl.style.marginLeft = '';
    if (breadcrumbsEl) {
      const breadcrumbX = `${breadcrumbsEl.getBoundingClientRect().bottom}px`;
      contentAreaEl.style.top = breadcrumbX;
      if (bannerSectionsEl) {
        bannerSectionsEl.style.top = breadcrumbX;
        if (asideEl) {
          asideEl.style.top = `${bannerSectionsEl.getBoundingClientRect().bottom + 10}px`;
        }
      }
    }
  }
}

setPosition();

// Set menu scroll position
if (window.sessionStorage.menuScrollPos) {
  if (menuElement) {
    menuElement.scrollTop = Number(
      window.sessionStorage.getItem('menuScrollPos'),
    );
  }
  window.sessionStorage.removeItem('menuScrollPos');
}

// Save menu scroll position on page unload
window.onbeforeunload = () => {
  if (menuElement) {
    window.sessionStorage.setItem(
      'menuScrollPos',
      String(menuElement.scrollTop),
    );
  }
};

// Reset the menu width and margin/offset for the content when the window
// is resized below 1024px. This prevents strange behaviors when the page
// switches over to the mobile menu.
//
// The style attributes are set directly on the elements by even listeners
// in `Sidebar.tsx`.
window.addEventListener('resize', function () {
  if (window.innerWidth <= 1024) {
    document.querySelectorAll<HTMLElement>('.menu').forEach(function (el) {
      el.style.width = '';
    });
    if (footerEl) {
      footerEl.style.width = '';
    }
  }
  setPosition();
});

/*
Note this is the hydration for the dynamic sidebar
https://confluence.silabs.com/pages/viewpage.action?pageId=122855251
*/
const hydrateMenu = async () => {
  const pathname = window.location.pathname;

  const {
    menu,
    docSpace,
    docLeaf,
    pdfExists,
    relPath,
    isStatic,
    tagSet,
    toc,
    versionsHistory,
  } = JSON.parse((window as any).__SUDS_DATA__);

  try {
    await decorateClientMenu(
      menu,
      docSpace,
      docLeaf,
      pathname,
      relPath,
      isStatic,
    );
    setMenuExpanded(menu);
  } catch (err) {
    throw new Error(`Error building menu ${err}`);
  }

  ReactDOM.hydrate(
    <PageContext.Provider
      value={{
        isStatic,
        pdfMode: false,
        pdfExists,
        relPath,
        docSpace,
        docLeaf,
        tagSet,
        pathname,
        toc,
      }}
    >
      <DynamicNav menu={menu} />
    </PageContext.Provider>,
    document.getElementById('dyn-nav'),
  );

  ReactDOM.hydrate(
    <PageContext.Provider
      value={{
        isStatic,
        pdfMode: false,
        pdfExists,
        relPath,
        docSpace,
        docLeaf,
        tagSet,
        pathname,
        toc,
      }}
    >
      <Header />
    </PageContext.Provider>,
    document.getElementById('header'),
  );

  ReactDOM.hydrate(
    <PageContext.Provider
      value={{
        isStatic,
        pdfMode: false,
        pdfExists,
        relPath,
        docSpace,
        pathname,
        versionsHistory,
      }}
    >
      <BannerHistory />
    </PageContext.Provider>,
    document.getElementById('banner'),
  );
};
const hydrate = (window as any).__HYDRATE__;
if (hydrate) {
  // Top level await would be nice
  hydrateMenu()
    .then(() => {
      console.log('menu success');
    })
    .catch((err) => {
      console.log('menu error: ', err);
    });
}
